import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import type React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { AREA_LIST, validatePhoneNumber } from "../utils";
import { Input } from "./form-items";
interface PhoneInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> {
  value: string;
  onChange: (val: string) => void;
  area: string;
  /**
   * 包裹容器的自定义 className
   */
  wrapperClassName?: string;
}

/**
 * 手机号输入框，区号前置，受控组件
 * @param value 手机号（不含区号）
 * @param onChange 变更回调
 * @param area 地区代码（如 "HK"、"MO"、"TW"）
 */
export const PhoneInput: React.FC<PhoneInputProps> = t0 => {
  const $ = _c(46);
  let area;
  let className;
  let customPlaceholder;
  let disabled;
  let onChange;
  let rest;
  let value;
  let wrapperClassName;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      area,
      placeholder: customPlaceholder,
      disabled,
      className,
      wrapperClassName,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = area;
    $[2] = className;
    $[3] = customPlaceholder;
    $[4] = disabled;
    $[5] = onChange;
    $[6] = rest;
    $[7] = value;
    $[8] = wrapperClassName;
  } else {
    area = $[1];
    className = $[2];
    customPlaceholder = $[3];
    disabled = $[4];
    onChange = $[5];
    rest = $[6];
    value = $[7];
    wrapperClassName = $[8];
  }
  const {
    t
  } = useTranslation();
  let t1;
  if ($[9] !== customPlaceholder || $[10] !== t) {
    t1 = customPlaceholder || t("placeholder.phoneInput");
    $[9] = customPlaceholder;
    $[10] = t;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const actualPlaceholder = t1;
  let t2;
  if ($[12] !== area) {
    t2 = AREA_LIST.find(item => item.code === area);
    $[12] = area;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const areaInfo = t2;
  const phoneCode = areaInfo ? `+${areaInfo.phoneCode}` : "";
  let t3;
  if ($[14] !== onChange) {
    t3 = e => {
      const raw = e.target.value.replace(/\D/g, "");
      onChange(raw);
    };
    $[14] = onChange;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const handleInputChange = t3;
  let t4;
  if ($[16] !== area || $[17] !== areaInfo?.phoneCode || $[18] !== onChange) {
    t4 = value_0 => {
      const cleanedInput = value_0.replace(/\D/g, "");
      const result = validatePhoneNumber(cleanedInput, area);
      if (result.valid && result.normalizedPhone) {
        const areaCode = areaInfo?.phoneCode || "";
        const localNumber = result.normalizedPhone.replace(areaCode, "");
        if (localNumber !== value_0) {
          onChange(localNumber);
        }
      }
    };
    $[16] = area;
    $[17] = areaInfo?.phoneCode;
    $[18] = onChange;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const formatPhoneNumber = t4;
  let t5;
  if ($[20] !== formatPhoneNumber) {
    t5 = e_0 => {
      formatPhoneNumber(e_0.target.value);
    };
    $[20] = formatPhoneNumber;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const handleBlur = t5;
  let t6;
  if ($[22] !== formatPhoneNumber) {
    t6 = e_1 => {
      if (e_1.currentTarget?.value) {
        formatPhoneNumber(e_1.currentTarget.value);
      }
    };
    $[22] = formatPhoneNumber;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const handleSelect = t6;
  let t7;
  if ($[24] !== formatPhoneNumber) {
    t7 = e_2 => {
      setTimeout(() => {
        if (e_2.currentTarget?.value) {
          formatPhoneNumber(e_2.currentTarget.value);
        }
      }, 100);
    };
    $[24] = formatPhoneNumber;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const handleInput = t7;
  let t8;
  if ($[26] !== wrapperClassName) {
    t8 = clsx("relative w-full", wrapperClassName);
    $[26] = wrapperClassName;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== phoneCode) {
    t9 = <span className="pointer-events-none absolute top-1/2 left-0 -translate-y-1/2 px-3 text-sm text-gray-500 select-none">{phoneCode}</span>;
    $[28] = phoneCode;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== className) {
    t10 = cn("pl-14!", className);
    $[30] = className;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== actualPlaceholder || $[33] !== disabled || $[34] !== handleBlur || $[35] !== handleInput || $[36] !== handleInputChange || $[37] !== handleSelect || $[38] !== rest || $[39] !== t10 || $[40] !== value) {
    t11 = <Input type="tel" value={value} onChange={handleInputChange} onBlur={handleBlur} onSelect={handleSelect} onInput={handleInput} placeholder={actualPlaceholder} disabled={disabled} maxLength={15} className={t10} {...rest} />;
    $[32] = actualPlaceholder;
    $[33] = disabled;
    $[34] = handleBlur;
    $[35] = handleInput;
    $[36] = handleInputChange;
    $[37] = handleSelect;
    $[38] = rest;
    $[39] = t10;
    $[40] = value;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== t11 || $[43] !== t8 || $[44] !== t9) {
    t12 = <div className={t8}>{t9}{t11}</div>;
    $[42] = t11;
    $[43] = t8;
    $[44] = t9;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  return t12;
};